import { FieldError, useErrorId } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { DateRangePickerInput } from '@calendly/ui/components/date-range-picker-input';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useEffect, useState, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dateNotationSelector, timezoneSelector } from 'selectors/current_user';
import { userDateRangeFormat } from 'services/time_format';
import { ConfirmationPopup } from './confirmation_popup';
import { isEventsDeletionStatusSuccessSelector } from './selectors';
import { deleteEvents } from './slice';
const dateRangeContainerCss = "d1t3cz8q";
const DateRangeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dateRangeContainerCss, props.className)} />;
});
const textInputContainerCss = "t16172c4";
const TextInputContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textInputContainerCss, props.className)} />;
});
const DateRangeField = ({
  startDate,
  endDate,
  onChange,
  onFocus,
  error,
  placeholder
}) => {
  const errorId = useErrorId({
    error
  });
  const timezone = useSelector(timezoneSelector);
  const dateNotation = useSelector(dateNotationSelector);
  let value = '';
  if (startDate && endDate) {
    const [start, end] = userDateRangeFormat(moment(startDate), moment(endDate), dateNotation, 'date_small', 'date_small_with_year');
    value = `${start} – ${end}`;
  }
  return <DateRangeContainer>
      <DateRangePickerInput name="data_requests_date_range" value={value} aria-invalid={Boolean(error)} aria-describedby={errorId} timezone={timezone} startDate={startDate} endDate={endDate} maxDate={moment().tz(timezone).format('YYYY-MM-DD')} onFocus={onFocus} onChange={onChange} placeholder={placeholder} pastSelection />
      <FieldError text={error} id={errorId} />
    </DateRangeContainer>;
};
export const PeriodSection = () => {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [error, setError] = useState();
  const [isConfirming, setIsConfirming] = useState(false);
  const isEventsDeletionStatusSuccess = useSelector(isEventsDeletionStatusSuccessSelector);
  useEffect(() => {
    if (isEventsDeletionStatusSuccess) {
      setStartDate(null);
      setEndDate(null);
    }
  }, [isEventsDeletionStatusSuccess]);
  const dismissErrors = () => setError();
  const closeConfirmation = () => setIsConfirming(false);
  const onClickDelete = () => {
    if (!(startDate && endDate)) {
      setError(I18n.t('errors.messages.blank'));
    } else {
      setIsConfirming(true);
    }
  };
  const confirmDeletion = () => {
    closeConfirmation();
    dispatch(deleteEvents(startDate, endDate));
  };
  const handleDateRangeChange = ([start, end]) => {
    setStartDate(start);
    setEndDate(end);
  };
  return <FlexLayout direction="column" gap={24}>
      <TitleText level={3} size="x-small">
        {I18n.t('publisher.organization_settings.data_deletion.section.period.title')}
      </TitleText>
      <FlexLayout direction="column" gap={16}>
        <div data-testid="sub-description">
          {I18n.t('publisher.organization_settings.data_deletion.section.period.description')}
        </div>

        <TextInputContainer data-component="delete-events">
          <DateRangeField onChange={handleDateRangeChange} startDate={startDate} endDate={endDate} error={error} onFocus={dismissErrors} placeholder={I18n.t('publisher.organization_settings.data_deletion.section.period.field_placeholder')} />
          <Button decoration="danger" onClick={onClickDelete}>
            {I18n.t('publisher.action.delete')}
          </Button>
          {isConfirming && <ConfirmationPopup close={closeConfirmation} confirm={confirmDeletion} />}
        </TextInputContainer>
      </FlexLayout>
    </FlexLayout>;
};

require("./period.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./period.js");